import React from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import "./NotificationDropdown.css";

const NotificationDropdown = ({ onNotificationsClick, onAlertsClick }) => {
  return (
    <div
      className="notification-dropdown"
      style={{
        position: "absolute",
        top: "40px",
        right: 0,
        background: "#000",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        borderRadius: 7,
        minWidth: 180,
        zIndex: 1000,
        padding: "8px 0",
      }}
    >
      {/* ✅ Notifications click handler */}
      {/* <div
        className="dropdown-option"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "4px 8px",
          cursor: "pointer",
        }}
        onClick={onNotificationsClick}
      >
        <NotificationsIcon style={{ marginRight: 8 }} /> Notifications
      </div> */}

      <div
        className="dropdown-option"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "4px 8px",
          cursor: "pointer",
        }}
        onClick={onAlertsClick}
      >
        <ReportProblemIcon style={{ marginRight: 8 }} /> Alerts
      </div>
    </div>
  );
};

export default NotificationDropdown;
